import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
  width: 100%;

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;

export const Chip = styled.div`
  box-sizing: border-box;

  display: inline-flex;
  align-items: center;
  gap: 6px;

  padding: 6px 8px 6px 12px;
  border-radius: 999px;
  background-color: ${theme.colors.gray.Cinza_12};
`;

export const ChipLabel = styled.span`
  white-space: nowrap;

  font-family: Lato;
  font-size: 12px;
  font-weight: 700;
  color: ${theme.colors.gray.Cinza_2};
`;

export const ChipRemove = styled.button`
  all: unset;
  box-sizing: border-box;

  width: 16px;
  height: 16px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  cursor: pointer;
  color: ${theme.colors.gray.Cinza_7};

  transition: background-color .15s ease, color .15s ease;

  &:hover {
    background-color: ${theme.colors.gray.Cinza_10};
    color: ${theme.colors.gray.Cinza_2};
  }

  svg {
    display: block;
  }
`;

export const ClearAll = styled.button`
  all: unset;
  box-sizing: border-box;
  white-space: nowrap;
  cursor: pointer;
  padding: 4px;

  font-family: Lato;
  font-size: 12px;
  font-weight: 800;
  color: ${theme.colors.blue.Azul_link};

  &:hover {
    text-decoration: underline;
  }
`;
